import StyledSlider from "common/Slider/StyledSlider";
import styled from "styled-components";
import React from "react";
import { FilterSectionData } from "@shared/features/filters/types";
import { FilterType } from "@shared/types";

const PriceRangeFiltersSection = <T extends FilterType.PRICE_RANGE>({
  options,
  value,
  onChange,
}: FilterSectionData<T>) => {
  const includeZero = options[0] === 0;

  const getPriceSliderValues = () => {
    const marks: Record<string, string> = {};
    options.map((price, i) => {
      const markKey = (i * (100 / (options.length - 1))).toString();
      marks[markKey] = price ? "$".repeat(price) : "0";
    });
    return marks;
  };

  const convertRangeToOriginalValues = (priceRange: [number, number]) => {
    const toOriginalValue = (value: number) =>
      value / (100 / (options.length - 1)) + (includeZero ? 0 : 1);
    const convertedPriceRange: [number, number] = [
      toOriginalValue(priceRange?.[0]),
      toOriginalValue(priceRange?.[1]),
    ];
    return convertedPriceRange;
  };

  const convertRangeToSliderValues = (priceRange: [number, number] | []) => {
    const toSliderValue = (value: number) =>
      (includeZero ? value : value - 1) * (100 / (options.length - 1));
    const convertedPriceRange: [number, number] = priceRange.length
      ? [toSliderValue(priceRange[0]), toSliderValue(priceRange[1])]
      : [0, 0];
    return convertedPriceRange;
  };

  return (
    <Slider
      style={{ height: 38 }}
      marks={getPriceSliderValues()}
      step={null}
      range
      value={convertRangeToSliderValues(value)}
      tooltip={{ open: false }}
      onChange={(value) =>
        onChange(convertRangeToOriginalValues(value as [number, number]))
      }
    />
  );
};

export default PriceRangeFiltersSection;

const Slider = styled(StyledSlider)`
  margin: 20px 12px 0;
  .ant-slider-mark-text:last-of-type {
    left: 95% !important;
`;
